import api from './api';
import type {
  AdminNotification,
  AdminNotificationFormData,
  AdminNotificationListResponse,
  NotificationPreview,
  NotificationStatistics,
  NotificationTargeting,
  RecipientPreview,
} from '../types/adminNotification';

export const adminNotificationService = {
  async getAll(params?: {
    status?: string;
    type?: string;
    page?: number;
  }): Promise<AdminNotificationListResponse> {
    const response = await api.get<AdminNotificationListResponse>(
      '/api/admin/notifications',
      { params }
    );
    return response.data;
  },

  async getById(id: string): Promise<AdminNotification> {
    const response = await api.get<AdminNotification>(
      `/api/admin/notifications/${id}`
    );
    return response.data;
  },

  async create(data: AdminNotificationFormData): Promise<AdminNotification> {
    const response = await api.post<AdminNotification>(
      '/api/admin/notifications',
      data
    );
    return response.data;
  },

  async update(
    id: string,
    data: AdminNotificationFormData
  ): Promise<AdminNotification> {
    const response = await api.put<AdminNotification>(
      `/api/admin/notifications/${id}`,
      data
    );
    return response.data;
  },

  async delete(id: string): Promise<void> {
    await api.delete(`/api/admin/notifications/${id}`);
  },

  async preview(id: string, locale: string): Promise<NotificationPreview> {
    const response = await api.post<NotificationPreview>(
      `/api/admin/notifications/${id}/preview`,
      { locale }
    );
    return response.data;
  },

  async previewRecipients(
    targeting: NotificationTargeting
  ): Promise<RecipientPreview> {
    const response = await api.get<RecipientPreview>(
      '/api/admin/notifications/targeting/preview-recipients',
      { params: { targeting } }
    );
    return response.data;
  },

  async sendNow(id: string): Promise<{ message: string }> {
    const response = await api.post<{ message: string }>(
      `/api/admin/notifications/${id}/send-now`
    );
    return response.data;
  },

  async getStatistics(id: string): Promise<NotificationStatistics> {
    const response = await api.get<NotificationStatistics>(
      `/api/admin/notifications/${id}/statistics`
    );
    return response.data;
  },
};
